export const getTeamInitials = (name: string) => {
  const words = name
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .split(/\s+/)
    .filter(Boolean);
  return words
    .slice(0, 3)
    .map((word) => word[0].toUpperCase())
    .join("");
};

export const isValidImage = (url: string): Promise<boolean> =>
  new Promise<boolean>((resolve) => {
    const img = new Image();
    img.src = url;

    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
  }).catch(() => false);
